import React from 'react'
import PropTypes from 'prop-types'
import { launcherOpenUrl } from '../launcherBackend/launcher-command'

// We take the link from the markdown and change it
// We want to disable the onClick function since we are going to
// send a command with the url to the launcher background instead of
// opening the link ourselves
const renderers = {
    link({ href, title, children }) {
        const settings = {
            href,
            title,
            onClick: (e) => {
                e.preventDefault()
                launcherOpenUrl(href)
            },
        }
        return <a {...settings}>{children}</a>
    },
}

renderers.link.propTypes = {
    href: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.node,
}

export default renderers



// WEBPACK FOOTER //
// ./src/markdown/customRenderers.js